import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    paddingBottom: 20,
    paddingTop: 55,
    paddingHorizontal: 20,
  },
});
